<template>
  <v-container>
    <div><b> Iklan</b></div>
    <br />
    <v-card>
      <v-row class="mx-3 pt-2">
        <v-col cols="12" sm="8" class="d-flex align-center">
          <v-text-field
            :label="'Cari berdasarkan '+ berdasarkan"
            outlined
            dense
            @click="daftarUser = true"
            @keyup="getUser()"
            v-model="search"
            :suffix="'| Berdasarkan '+ berdasarkan"
            @keyup.enter="cariIklan(search.length)"
          >
            <template v-slot:append>
              <v-menu
                down
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </template>
                <v-list
                  class="px-4"
                >
                  <v-list-item @click="berdasarkan = 'id'">Berdasarkan Id</v-list-item>
                </v-list>
                <v-list
                  class="px-4"
                >
                  <v-list-item @click="berdasarkan = 'pengguna'">Berdasarkan Pengguna</v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-text-field>

        </v-col>
        <v-col cols="12" sm="4" class="d-flex align-center">
          <v-select
            outlined
            :items="inijenisIklan"
            dense
            v-model="jenis"
            single-line
            @change="getDataIklanCariId()"
          ></v-select>
        </v-col>
        <v-col v-if="berdasarkan =='pengguna' && daftarUser == true" cols="12" sm="8" style="position:absolute;z-index:10" class="mt-11">
          <v-list elevation="1" style="width:90%">
            <v-list-item
              
              class="mb-4"
            >
              <table style="width:100%">
                <tr v-for="(item, i) in iniListUser"
                  :key="i"
                  @click="memilihUser(item)"
                  style="cursor:pointer"
                >
                  <td style="width:70px">
                    <v-avatar>
                      <v-img src="img/beat.png"></v-img>
                    </v-avatar>
                  </td>
                  <td>{{item.nama}}</td>
                  <td class="text-right">
                    <v-icon>
                      mdi-chevron-right
                    </v-icon>
                  </td>
                </tr>
              </table>
            </v-list-item>
          </v-list>
        </v-col>

      </v-row>
      


      <div class="d-flex ml-6">
        <div
          :style="semua == 'Semua' ? 'background: #e9f4f5;border: 2px solid #c90000;border-radius: 10px;cursor:pointer' 
            : 'border: 2px solid #ffeeee; border-radius: 10px;cursor:pointer'"
          class="px-4 py-2"
          @click="tabIklan('Semua')"
        >
          Semua Iklan({{ countIklan }})
        </div>
        <!-- <div
          :style="semua == 'Pantau' ? 'background: #e9f4f5;border: 2px solid #c90000;border-radius: 10px;cursor:pointer' 
            : 'border: 2px solid #ffeeee; border-radius: 10px;cursor:pointer'"
          class="px-4 py-2 ml-2"
          @click="tabIklan('Pantau')"
        >
          Dipantau(12483)
        </div> -->
        <div
          :style="semua == 'Beku' ? 'background: #e9f4f5;border: 2px solid #c90000;border-radius: 10px;cursor:pointer' 
            : 'border: 2px solid #ffeeee; border-radius: 10px;cursor:pointer'"
          class="px-4 py-2 ml-2"
          @click="tabIklan('Beku')"
        >
          Dibekukan(12483)
        </div>
      </div>
      <br />
      <br />
      <div v-if="semua == 'Semua'">
          <!-- <v-row class="mx-1">
              <v-col
                cols="12"
                sm="3"
                v-for="item in dataIklan"
                :key="item._source.id"
              >
                <ListIklans :item="item" @DataTanda="tandai" />
              </v-col>
            </v-row>
          <br />
          <div align="center">
            <v-btn
              color="#c90000"
              dark
              outlined
              @click="getDataIklan"
              v-if="dataIklan.length < 1000 && dataIklan.length < total"
            >
              Muat Lebih Banyak
            </v-btn>
          </div>
          <br> -->
          <v-data-table
          :headers="headersAktif"
          hide-default-footer
          :items="dataIklan"
          show-select
          class="elevation-1 listdibekukan"
        >
        </v-data-table>
      </div>
      <div v-if="semua == 'Beku'">
        <v-data-table
          :headers="headers"
          hide-default-footer
          :items="iklanBekukan"
          show-select
          class="elevation-1 listdibekukan"
        >
          <template v-slot:[`item.iklan`]="{ item }">
            <!-- <v-row>
              <v-col cols="12" sm="3">
                <div style="width:80px;" class="my-2"><v-img style="border-radius:10px" src="img/beat.png"></v-img></div>
              </v-col>
              <v-col cols="12" sm="9">
                <div class="red--text">
                  Dibekukan
                </div>
              </v-col>
            </v-row> -->
            <table style="width:100%" class="mx-4 py-2">
              <tr>
                <td>
                  <div style="width:80px;" class="my-2"><v-img style="border-radius:10px" src="img/beat.png"></v-img></div>
                </td>
                <td class="pl-2">
                  <div class="red--text px-1 py-1 text-center" style="background:#FFF4F2;border-radius:10px;width:80px">Dibekukan</div>
                  <div>Oleh : {{item.oleh}}</div>
                  <div>Deskripsi motor ini adalah wkwkwk</div>
                </td>
              </tr>
            </table>
          </template>
          <template v-slot:[`item.aksi`]="{  }">
            <v-btn x-small elevation="0" style="border:1px solid #c90000;color:#c90000">Aktifkan</v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-card
      style="position: fixed; bottom: 0"
      class="py-1"
      width="77.5%"
      elevation="5"
      v-if="semua =='Semua'"
    >
      <v-row>
        <v-col cols="12" sm="8">
          <v-checkbox label="Pilih Semua" v-model="tandaiSemua" @change="tandaiAll()"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="d-flex pt-2">
            <div class="pt-1">{{ diTandai.length }} Iklan Terpilih</div>
            <div
              @click="dialogBekukan = true"
              class="pt-1 ml-4"
              style="
                cursor: pointer;
                color: #c90000;
                border: 2px solid #c90000;
                width: 40%;
                border-radius: 7px;
              "
            >
              <center>Bekukan</center>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    
    <br />
    <br />
  </v-container>
</template>

<script>
import 'firebase/firestore';
import { db } from '../main';
import moment from 'moment-timezone';
import ListIklans from '@/components/ListIklans.vue';

export default {
  components: {
    ListIklans,
  },
  name: 'ListIklan',
  data: () => ({
    selected: [2],
    RenderList: true,
    LogTransaksi: null,
    itemsPerPage: 999,
    DetailIklan: [],
    search: '',
    bidder: [],
    IklanSatuan: false,
    unitMokas: [],
    TransaksiDetail: false,
    fotos: [],
    utc: moment().utcOffset() / 60 - 7,
    waktu: '',
    appuser: [],
    IklanPaketan: false,
    motorBekas: [],
    // inijenisIklan: [
    //   { name: "Tawar Bersama", id: "" },
    //   { name: "Iklan Baris", id: "" },
    //   { name: "Aksesoris dan Suku Cadang", id: "" },
    //   { name: "Semua", id: "" }
    // ],
    headers: [
      { text: "Id iklan", value: "_source.id" },
      { text: "Nama Penjual", value: "nama_penjual" },
      { text: "Iklan", value: "iklan" },
      { text: "Tipe Iklan", value: "tipe_iklan" },
      { text: "Tanggal Dibekukan", value: "tanggal_dibekukan" },
      { text: "Alasan Dibekukan", value: "alasan_dibekukan" },
      { text: "Aksi", value: "aksi" },
    ],
    headersAktif: [
      { text: "Id iklan", value: "id" },
      { text: "Nama Penjual", value: "nama_penjual" },
      { text: "Iklan", value: "iklan" },
      { text: "Tipe Iklan", value: "tipe_iklan" },
      { text: "Aksi", value: "aksi" },
    ],
    inijenisIklan: [
      'Tawar Bersama',
      'Iklan Baris',
      'Aksesoris dan Suku Cadang',
      'Semua',
    ],
    iklanBekukan: [
      {
        id:1234,
        nama_penjual:'Clief',
        tipe_iklan:'iklan baris',
        oleh:'deni',
        tanggal_dibekukan:'04 Mar 2021 10.20 WIB',
        alasan_dibekukan:'tipu tipu',
      },
      {
        id:4321,
        nama_penjual:'Benyal',
        tipe_iklan:'iklan_baris',
        oleh:'candra',
        tanggal_dibekukan:'04 Mar 2021 10.20 WIB',
        alasan_dibekukan:'boongan',
      },
    ],
    dialogBekukan: false,
    alasanBekukan: '',
    dataIklan:[],
    jenis:'Iklan Baris',
    semua: 'Semua',
    limit: 20,
    page: 1,
    offset: 0,
    total: 0,
    lengthPage: 0,
    tandaiSemua: false,
    diTandai:[],
    dataAdmin:'',
    berdasarkan: '',
    iniListUser:[],
    pickIdUser:'',
    daftarUser:false,
    countIklan:'',
      // headers: [
      //   { text: 'ID Iklan', value: 'id' },
      //   { text: 'Nama Penjual', value: 'nama_' },
      //   // { text: 'iklan', value: 'photo' },
      //   { text: 'Judul', value: 'Judul' },
      //    { text: 'Jenis Iklan', value: 'mst_iklan_jenis' },
      //   { text: 'Aksi', value: 'actions' },
       
      // ],
  }),
  methods: {
    async getDataIklan() {
      let offset = (this.page - 1) * this.limit
      let params = new URLSearchParams()

      params.set('id_mst_iklan_status', 1)
      params.set('limit', this.limit)
      params.set('offset', offset)
      if (this.jenis == "Iklan Baris") {
        params.set('id_mst_iklan_jenis', 1)
      }
      if (this.jenis == "Tawar Bersama") {
        params.set('id_mst_iklan_jenis', 2)
      }
      if (this.jenis == "Aksesoris dan Suku Cadang") {
        params.set('id_mst_iklan_jenis', 5)
      }
      // if (this.berdasarkan == "id") {
      //   if (this.search != "") {
      //     params.set('id', this.search)
      //   }
      // }
      // if (this.berdasarkan == "pengguna") {
      //   if (this.search != "") {
      //     params.set('id_app_user', this.pickIdUser)
      //     }
      // }

      let request = {
        params: params,
      }
      await this.$req
        .get(this.$root.$baseapi.search+'/search/v3/search',request)
        .then((response) => {
          let data = response.data
          let { hits } = data.hits
          this.dataIklan = hits

          this.total = data.hits.total.value
          this.lengthPage = Math.ceil(this.total / this.limit)
          this.page++
          this.countIklan = response.data.hits.total.value
          console.log('data Iklan', this.dataIklan)
        })
        .catch((error) => {
          let responses = error.response.data
          console.log(responses.api_message)
        })
    },
    async getDataIklanPush() {
      let offset = (this.page - 1) * this.limit
      let params = new URLSearchParams()

      params.set('id_mst_iklan_status', 1)
      params.set('limit', this.limit)
      params.set('offset', offset)
      if (this.jenis == "Iklan Baris") {
        params.set('id_mst_iklan_jenis', 1)
      }
      if (this.jenis == "Tawar Bersama") {
        params.set('id_mst_iklan_jenis', 2)
      }
      if (this.jenis == "Aksesoris dan Suku Cadang") {
        params.set('id_mst_iklan_jenis', 5)
      }
      if (this.berdasarkan == "id") {
        if (this.search != "") {
          params.set('id', this.search)
        }
      }
      if (this.berdasarkan == "pengguna") {
        if (this.search != "") {
          params.set('id_app_user', this.search)
          }
      }
      

      let request = {
        params: params,
      }
      await this.$req
        .get(this.$root.$baseapi.search+'/search/v3/search',request)
        .then((response) => {
          let data = response.data
          let { hits } = data.hits
          this.dataIklan.push(...hits)
          for (let i = 0; i < this.dataIklan.length; i++) {
            if (this.dataIklan[i]._score == null) {
              this.dataIklan[i]._score = false
            }else if (this.dataIklan[i]._score == false) {
              this.dataIklan[i]._score = false
            }else if (this.dataIklan[i]._score == true) {
              this.dataIklan[i]._score = true
            }
          }

          this.total = data.hits.total.value
          this.lengthPage = Math.ceil(this.total / this.limit)
          this.page++
          this.countIklan = response.data.hits.total.value
          console.log('total', this.dataIklan)
        })
        .catch((error) => {
          let responses = error.response.data
          console.log(responses.api_message)
        })
    },
    async tabIklan(data){
      if (data == "Semua") {
        this.semua = 'Semua'
      }
      if (data == "Pantau") {
        this.semua = 'Pantau'
      }
      if (data == "Beku") {
        this.semua = 'Beku'
      }
    },
    async tandai(param){
      let ada = false
      for (let i = 0; i < this.diTandai.length; i++) {
        if (this.diTandai[i].id == param._id) {
          ada = true
          this.diTandai.splice(i,1)
        }
      }
      if (ada == false) {
        this.diTandai.push({id:param._id})
      }
      if (this.diTandai.length < this.dataIklan.length) {
        this.tandaiSemua = false
      }
      if (this.diTandai.length == this.dataIklan.length) {
        this.tandaiSemua = true
      }
      console.log('yang ditandai', this.diTandai)
    },
    async tandaiAll(){
      for (let i = 0; i < this.dataIklan.length; i++) {
        if (this.tandaiSemua == true) {
          this.dataIklan[i]._score = true
        }else if (this.tandaiSemua == false) {
          this.dataIklan[i]._score = false
        }
      }
      if (this.tandaiSemua == true) {
        this.diTandai = []
        for (let i = 0; i < this.dataIklan.length; i++) {
          this.diTandai.push({id:this.dataIklan[i]._id})
        }
      }else if (this.tandaiSemua == false) {
        this.diTandai = []
      }
      console.log('yang ditandai', this.diTandai)
    },
    async cariIklan(cari){
      if (cari == 0) {
        this.dataIklan = []
        this.limit= 20,
        this.page= 1,
        this.offset= 0,
        this.total= 0,
        this.lengthPage= 0,
        this.getDataIklan()
      }
      if (cari != 0) {
        this.getDataIklanCariId()
      }
    },
    async getUser(){
        if (this.berdasarkan != 'id') {
          let params = new URLSearchParams()

          params.set('limit', 5)
          
          if (this.search != '') {
            params.set('search', this.search)
          }
          

          let request = {
            params: params,
          }
          await this.$req
            .get(this.$root.$baseapi.user+'/user/v3/user',request)
            .then((response) => {
              this.iniListUser = response.data.data
              console.log('data user', this.iniListUser)
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },
    async memilihUser(item){
      this.pickIdUser = item.id
      this.search = item.nama
      this.daftarUser = false
      this.getDataIklanCariId()
    },
  },

  computed: {},

  async created() {
    if (this.utc == 0) {
      this.waktu = 'WIB';
    }
    if (this.utc == 1) {
      this.waktu = 'WITA';
    }
    if (this.utc == 2) {
      this.waktu = 'WIT';
    }
    this.getDataIklan()
    this.getUser()
    this.idAdmin = localStorage.getItem('id')
  },
  filters: {
    dateTimeFormat: (date, utc) => {
      return moment.utc(date).add(utc, 'h').format('DD MMM YYYY HH:mm');
    },
    TimeFormat: (date, utc) => {
      return moment.utc(date).add(utc, 'h').format('HH:mm');
    },
    dateFormat: (date, utc) => {
      return moment.utc(date).add(utc, 'h').format('DD MMM YYYY');
    },
    datediff: (date) => {
      return moment(date).from();
    },
  },
};
</script>
